"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "sanitizeRoleName", {
    enumerable: true,
    get: function() {
        return sanitizeRoleName;
    }
});
// The invisible formatting characters that survive trim — zero-width space, LRM/RLM, bidi
// embeddings/overrides, word joiner + invisible operators, bidi isolates, BOM. Deliberately
// KEEPS ZWNJ/ZWJ (U+200C/U+200D): orthographic in Persian and Indic names — a blanket \p{Cf}
// strip would corrupt them. Every character here (and in the control class below) is
// ICU-collation-ignorable at strength 2, so stripping opens no new name collisions.
const INVISIBLE_ROLE_NAME_CHARS = /[\u200B\u200E\u200F\u202A-\u202E\u2060-\u2064\u2066-\u2069\uFEFF]/gu;
// Cc controls that are NOT whitespace vanish; the whitespace controls (\t \n \v \f \r) become
// spaces via the run collapse below instead of welding words together.
const NON_WHITESPACE_CONTROL_CHARS = /[\u0000-\u0008\u000E-\u001F\u007F-\u009F]/gu;
const sanitizeRoleName = (raw)=>raw.replace(INVISIBLE_ROLE_NAME_CHARS, "").replace(NON_WHITESPACE_CONTROL_CHARS, "").replace(/[ \t\n\r\f\v]+/g, " ").trim().normalize("NFC");
